import React from 'react';
import '../../utils/assertions.es.js';
import { runIfFn } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { useNavBarContext } from './NavBarContext.es.js';
import { Menu } from './styled.es.js';

var NavBarMenu = function NavBarMenu(_ref) {
  var justify = _ref.justify,
      children = _ref.children;

  var _useNavBarContext = useNavBarContext(),
      isMobile = _useNavBarContext.isMobile;

  return isMobile ? runIfFn(children, {
    isMobile: isMobile
  }) :
  /* @__PURE__ */
  React.createElement(Menu, {
    justify: justify
  }, runIfFn(children, {
    isMobile: isMobile
  }));
};

NavBarMenu.displayName = "NavBar.Menu";
export { NavBarMenu };